import { useMemo } from "react";
import { motion } from "framer-motion";
import { Sparkles, ArrowRight } from "lucide-react";

const CAMP_START = new Date("2026-12-14T09:00:00");
const EARLY_BIRD_END = new Date("2026-11-01T23:59:59");
const DAY_MS = 24 * 60 * 60 * 1000;

export const Countdown = ({ onNavigate }) => {
  const days = useMemo(
    () => Math.max(0, Math.ceil((CAMP_START.getTime() - Date.now()) / DAY_MS)),
    []
  );
  const earlyBirdOn = Date.now() <= EARLY_BIRD_END.getTime();

  return (
    <section
      className="relative overflow-hidden bg-yellow-400 py-12 md:py-16"
      data-testid="countdown-section"
    >
      <div className="pointer-events-none absolute -top-16 -right-16 h-56 w-56 rounded-full bg-white/30 blur-3xl" />
      <div className="relative z-10 mx-auto max-w-7xl px-5 flex flex-col md:flex-row items-center justify-between gap-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-6"
        >
          <span
            className="font-display font-black leading-none text-slate-900 text-7xl md:text-8xl"
            data-testid="countdown-days"
          >
            {days}
          </span>
          <div>
            <p className="font-display font-extrabold text-2xl md:text-3xl text-slate-900 leading-tight">
              sleeps until the
              <br />
              Christmas Camp!
            </p>
            <p className="mt-1 font-bold text-slate-800/70 text-sm">
              Mon 14 – Thu 17 December · The Downs Preparatory School
            </p>
          </div>
        </motion.div>

        {earlyBirdOn && (
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-start md:items-end gap-3"
          >
            <p className="inline-flex items-center gap-2 font-bold text-slate-900">
              <Sparkles className="h-5 w-5" />
              Early-bird prices end 1 November — don&apos;t miss out
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.96 }}
              onClick={() => onNavigate("#booking")}
              data-testid="countdown-book-button"
              className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-7 py-3.5 font-display font-bold text-white shadow-[0_12px_30px_rgba(15,23,42,0.3)] hover:bg-sky-500 transition-colors"
            >
              Book your child&apos;s place <ArrowRight className="h-5 w-5" />
            </motion.button>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Countdown;
